class CollectionInfiniteScroll extends HTMLElement {
    constructor(config) {
        super();

        const settings = config || {}

        const defaultSettings = {
            pagination: '#AjaxinatePagination',
            method: 'scroll',
            container: '#product-grid',
            offset: 0,
        }

        this.settings = Object.assign(defaultSettings, settings)

        // Bind 'this' to applicable prototype functions
        this.addScrollListeners = this.addScrollListeners.bind(this)
        this.addClickListener = this.addClickListener.bind(this)
        this.checkIfPaginationInView = this.checkIfPaginationInView.bind(this);
        this.stopMultipleClicks = this.stopMultipleClicks.bind(this);
        this.destroy = this.destroy.bind(this);

        // Set up our element selectors
        this.containerElement = document.querySelector(this.settings.container)
        this.paginationElement = document.querySelector(this.settings.pagination)

        this.initialize()
    }

    initialize() {
        if (this.containerElement) {
            const initializers = {
                click: this.addClickListener,
                scroll: this.addScrollListeners
            }
            initializers[this.settings.method]();
        }
    }

    addScrollListeners() {
        if (this.paginationElement) {
            document.addEventListener('scroll', this.checkIfPaginationInView)
            window.addEventListener('resize', this.checkIfPaginationInView);
            window.addEventListener('orientationchange', this.checkIfPaginationInView);
        }
    }

    addClickListener() {
        if (this.paginationElement) {
            this.nextPageLinkElement = this.paginationElement.querySelector('a');
            this.clickActive = true;
            if (this.nextPageLinkElement !== null) {
                this.nextPageLinkElement.addEventListener('click', this.stopMultipleClicks);
            }
        }
    }

    stopMultipleClicks(event) {
        event.preventDefault();
        if (this.clickActive) {
            this.nextPageLinkElement.innerHTML = this.settings.loadingText;
            this.nextPageUrl = this.nextPageLinkElement.href;
            this.clickActive = false;
            this.loadMore();
        }
    }

    checkIfPaginationInView() {
        const top = this.paginationElement.getBoundingClientRect().top - this.settings.offset;
        const bottom = this.paginationElement.getBoundingClientRect().bottom + this.settings.offset;
        if (top <= window.innerHeight && bottom >= 0) {
            console.log('is in view')
            this.nextPageLinkElement = this.paginationElement.querySelector('button');
            this.removeScrollListener();
            if (this.nextPageLinkElement) {
                this.nextPageLinkElement.innerHTML = `<span class="btn-text">${this.settings.loadingText}</span>`;
                this.nextPageLinkElement.classList.add('loading')
                this.nextPageLinkElement.setAttribute('disabled', 'disabled')
                this.nextPageUrl = this.nextPageLinkElement.getAttribute('data-href');
                this.loadMore();
            }
        }
    }

    loadMore() {
        console.log('loading more')
        this.request = new XMLHttpRequest();
        this.request.onreadystatechange = function success() {
            if (this.request.readyState === 4 && this.request.status === 200) {
                var newContainer = this.request.responseXML.querySelectorAll(this.settings.container)[0];
                var newPagination = this.request.responseXML.querySelectorAll(this.settings.pagination)[0];
                this.containerElement.insertAdjacentHTML('beforeend', newContainer.innerHTML);
                this.paginationElement.innerHTML = newPagination.innerHTML;
                if (this.settings.callback && typeof this.settings.callback === 'function') {
                    this.settings.callback(this.request.responseXML);
                }
                this.initialize();
            }
        }.bind(this);
        this.request.open('GET', this.nextPageUrl);
        this.request.responseType = 'document';
        this.request.send();
    }

    removeClickListener() {
        this.nextPageLinkElement.addEventListener('click', this.stopMultipleClicks);
    }

    removeScrollListener() {
        document.removeEventListener('scroll', this.checkIfPaginationInView);
        window.removeEventListener('resize', this.checkIfPaginationInView);
        window.removeEventListener('orientationchange', this.checkIfPaginationInView);
    }

    destroy() {
        // This method is used to unbind event listeners from the DOM
        const destroyers = {
            click: this.removeClickListener,
            scroll: this.removeScrollListener
        };
        destroyers[this.settings.method]();
        return this;
    }
}

customElements.define('infinite-scroll', CollectionInfiniteScroll)